import { InvoiceProvider } from '../../common/InvoiceProvider';
import { WorkflowProvider } from 'components/Workflow/WorkflowContext';
import { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Divider,
  Button,
  Input,
} from '@mui/material';
import Spinner from '../../Spinner';
import intl from 'components/i18n/ReactIntlWrapper';
import ErrorSummary from '../../common/ErrorSummary';
import InvoiceUploadDropZone from './InvoiceUploadDropZone';
import { useInvoice } from '../../common/InvoiceProvider';
import { useNavigate } from 'react-router';
import { useApi } from 'api/ApiProvider';
import Api from 'axiosApi/api';

const InvoiceUploadContent = ({ review = false, view = false }) => {
  const {
    input,
    isLoading,
    errors,
    setErrors,
  } = useInvoice();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const api: Api = useApi();

  const handleUpload = async function () {
    setLoading(true);
    try {
      if (!input?.attachments?.[0]) {
        throw new Error('No file selected');
      }
      await api.invoiceApi.apiVversionInvoiceUploadPost('1', input?.attachments?.[0]);
    } catch (error) {
      setErrors((prevErrors) => ({ ...prevErrors, attachments: error.message }));
      throw error;
    } finally {
      setLoading(false);
      navigate('/myInvoices');
    }
  };

  return (
        <Box sx={{ mt: 4, px: 2 }}>
          <Card variant="outlined">
            {(isLoading || loading) && <Spinner />}
            <CardHeader
              title={
                <Typography color="primary" variant="h2">
                  {review ? intl.get('newInvoice.validation') : intl.get('newInvoice.header')}
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={2}>
                <Grid sx={{ xs: 12 }}>
                  <ErrorSummary errors={errors} showEverything={true} />
                </Grid>
                <Grid sx={{ xs: 12 }}>
                  <Typography
                    sx={{ mt: errors?.idFrom && errors?.idFrom !== 'missing confidence' ? -3 : 0 }}
                    color={errors?.idFrom ? 'error' : 'primary'}
                    variant="body2"
                  >
                    {errors?.idFrom && errors?.idFrom !== 'missing confidence' && errors?.idFrom}
                  </Typography>
                  {view ? (
                    <Box
                      component="input"
                      type="text"
                      value={input.personaFrom?.name || ''}
                      disabled
                      sx={{ width: '100%', p: 1, mt: 1, border: '1px solid #ccc', borderRadius: 1 }}
                    />
                  ) : (
                    <Input
                      id="from"
                      name="from"
                      value={input?.from || ''}
                      fullWidth
                      sx={{ width: '100%', p: 1, mt: 1, border: '1px solid #ccc', borderRadius: 1 }}
                      size="small"
                      disabled={true}
                      disableUnderline
                    />
                  )}
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              <Grid container spacing={2} alignItems="flex-start">
                <Grid sx={{ xs: 12, width: '100%', md: 5 }}>
                  <InvoiceUploadDropZone review={review} view={view} />
                </Grid>
                <Grid
                  sx={{
                    xs: 12,
                    width: '100%',
                    md: 0,
                  }}
                >
                  <Grid className="d-flex justify-content-end" sx={{ marginTop: '20px' }}>
                    <Box
                      className="workflow-actions-bar"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={1}
                      height="100%"
                      width="100%"
                    >
                      <Button variant="outlined" color="inherit" onClick={() => navigate('/myInvoices')}>
                        {intl.get('workflow.action.cancel')}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ zIndex: 5 }}
                        onClick={handleUpload}
                        disabled={!input?.attachments?.[0]}
                      >
                        Upload
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
  );
};

const InvoiceUpload = () => {
  return (
    <InvoiceProvider review={false} view={false}>
      <WorkflowProvider moduleId={3}>
        <InvoiceUploadContent />
      </WorkflowProvider>
    </InvoiceProvider>
  );
};

export default InvoiceUpload;
